import React from 'react';

const Hero = () => {
  const nextPerformance = {
    location: "Luna May Day Gathering and Bazaar",
    date: "May 2, 2026",
    spot: "Berkeley • 2:00 PM"
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden" 
      style={{
        background: 'linear-gradient(120deg, #FC9C24 0%, #E454B4 35%, #5454B4 65%, #0C9CCC 100%)'
      }}>
      
      {/* Radial orbs for depth */}
      <div 
        className="absolute top-0 left-0 w-[200px] h-[200px] rounded-full opacity-50"
        style={{
          background: '#FCCC54',
          filter: 'blur(60px)'
        }}
      ></div>
      <div 
        className="absolute bottom-0 right-0 w-[180px] h-[180px] rounded-full opacity-50"
        style={{
          background: '#24B4E4',
          filter: 'blur(60px)'
        }}
      ></div>
      
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8">
        <div className="mb-6">
          <img 
            src="/logo-purple.png" 
            alt="Offbeat Crew" 
            className="w-64 md:w-80 h-auto mx-auto"
          />
        </div>
        
        <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto leading-relaxed" 
          style={{
            color: 'rgba(255,255,255,.88)'
          }}>
          Bringing joy to the Bay Area through spontaneous flash mobs and fusion dance performances
        </p>
        
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 max-w-md mx-auto border border-white/20">
          <p className="text-white/80 text-sm mb-2">Next Performance</p>
          <p className="text-white text-xl font-semibold mb-1" style={{textShadow: '0 2px 20px rgba(0,0,80,.2)'}}>{nextPerformance.location}</p>
          <p className="text-white/90 mb-2">{nextPerformance.date} • {nextPerformance.spot}</p>
          <p className="text-white/80 text-sm mb-4 italic">Performance + audience dance workshop • Free family event</p>
          <button 
            onClick={() => document.getElementById('tour')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-white text-mid-purple px-6 py-2 rounded-full text-sm font-semibold hover:bg-gray-100 transition-colors duration-300 transform hover:scale-105 w-full"
            style={{borderRadius: '30px'}}
          >
            View Details
          </button>
        </div>
        
        <div className="mt-16 animate-bounce-slow">
          <svg className="w-8 h-8 text-white mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default Hero;
